import React from 'react';

import './styles.scss';

export default function LineChartHeader({ text }) {
  return <h1 className="line-chart-header">{text}</h1>;
}
